import '@/styles/global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { setViewerTimeZone } from '@/utils/dateUtils';

import { App } from './App';

// Times are stated in IST platform-wide; a viewer elsewhere also sees their own time in parentheses.
// Declared here, once, before the first render — the formatters never read the host zone themselves, so
// that a wrong or unreadable zone degrades to a correct IST-only string (see `dateUtils`).
setViewerTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
